// extracted by mini-css-extract-plugin
export default {"block-container":"styles_block-container__1ghvo","title":"styles_title__0Yjyb","autocomplete-block":"styles_autocomplete-block__gssYp"};